import { breakpoints, spacing } from '@naf/theme';
import styled from '@emotion/styled';

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.space16};
  margin-top: ${spacing.space24};

  @media (max-width: ${breakpoints.s}) {
    flex-direction: column;
    gap: ${spacing.space24};
  }
`;
